import { fetchData } from './fetchData';
import { Machine, MachineLocation } from '../data/Machine';

export type GetMachineRequestData = {
    line_uid: string,
    login: string,
};

type GetMachineStateResponseData = Machine[];
type GetMachineLocationListResponseData = MachineLocation[];

/**
 * @description LINE ID與帳號擇一傳入,不可模糊查詢
 */
function machineState(data: GetMachineRequestData): Promise<Machine[]> {
    return fetchData('api/machine_state', {
        method: 'POST',
        body: JSON.stringify(data),
    })
        .then((res) => res.json())
        .then((resData: GetMachineStateResponseData) => resData);
}

/**
 * @description LINE ID與帳號擇一傳入,不可模糊查詢
 */
function machineLocationList(data: GetMachineRequestData): Promise<MachineLocation[]> {
    return fetchData('api/machine_location_list', {
        method: 'POST',
        body: JSON.stringify(data),
    })
        .then((res) => res.json())
        .then((resData: GetMachineLocationListResponseData) => resData);
}

export { machineState, machineLocationList };
